"use strict";

var LoggerInstance = require("js-logger").get("SuggestedDonationHelper");

var Constants = require("../designer/Constants");

var Dispatcher = require("../dispatcher/Dispatcher");

var InputHelper = require("../shared/InputHelper");

module.exports = {
	/**
	 * Logic Functionality
	 **/
	initializeDonationAmount(checkoutDispatcher, component, productCode, context, suggestedDonationAmount) {
		var $component = $(component);
		$component.attr("data-show-decimals", "");
		InputHelper.initializeAmountInput(
			$component, /*$component*/
			$component, /*amountSelector*/
			null, /*allowDecimal*/
			false, /*greaterThanZero*/
			null, /*formatAmount*/
			null, /*defaultValue*/
			false /*includeThousandsSeparator*/
		);


		$component.on("change", event => {
			this.handleSuggestedDonationChange(event, checkoutDispatcher, productCode, context);
		});

		// if we're in a context, we need to initialize each suggested donation amount
		if (context) {
			this.initializeSuggestedDonationAmount(suggestedDonationAmount, context, productCode);
		}
	},

	handleSuggestedDonationChange: function (event, checkoutDispatcher, productCode, context) {
		// update data in the store, store will call UI update method.
		var amount = event.target.value;

		this.setSuggestedDonationAmount(amount, context, productCode);

		// We only want to call this from product page.
		if (!context && checkoutDispatcher) {
			checkoutDispatcher.dispatch({
				actionType: Constants.CART_UPDATE_PRODUCT_PRICE,
				productPrice: amount
			});
		}
	},

	initializeSuggestedDonationAmount: function (amount, context, productCode) {
		Dispatcher.dispatch({
			actionType: Constants.PRODUCT_INITIALIZE_SUGGESTED_DONATION,
			amount,
			productCode,
			context
		});
	},

	setSuggestedDonationAmount: function (amount, context, productCode) {
		Dispatcher.dispatch({
			actionType: Constants.PRODUCT_SET_SUGGESTED_DONATION,
			amount,
			productCode,
			context
		});
	},

	validateAmount(amount, suggestedDonationAmount) {
		// If SD is 0 (not falsey) we're in a no-min and the value has to be > 0.01. Otherwise the donation
		// has to be greater than OR EQUAL to the default amount.
		if (suggestedDonationAmount === 0) {
			return amount >= 0.01;
		} else {
			return amount >= suggestedDonationAmount;
		}
	},

	/**
	 * UI Functionality
	 **/
	updateSuggestedDonationComponent(amount, context, productCode) {
		// update the component UI to make sure that the SD amount matches what's in the store.
		var $component = this.findComponentFor(context, productCode, "suggestedDonationAmount");
		$component.val(Number(amount).toFixed(2));
	},

	findComponentFor(context, productCode, componentName) {
		if (context) {
			var componentContext = context.split("_")[0];
			if (componentContext === "search") {
				componentContext = "searchResults";
			}
			return $(`[data-component="${componentContext}.product"][data-product-code="${productCode}"]`).find(`[data-component="${componentName}"]`);
		} else {
			var component = $(`[data-component="${componentName}"]`).filter((index, item) => {
				return $(item).parents('[data-component="searchResult.product"],[data-component="category.product"],[data-component="carousel.product"]').length === 0;
			})[0];

			return $(component);
		}
	},

	isOnePageSuggestedDonation() {
		var suggestedDonationComponent = $('[data-component="suggestedDonationAmount"]').filter((index, item) => {
			return $(item).parents('[data-component="searchResult.product"],[data-component="category.product"],[data-component="carousel.product"]').length === 0;
		});

		return suggestedDonationComponent.length > 0;
	},

	showInvalidSuggestedDonationMessage(context, productCode) {
		this.findComponentFor(context, productCode, "suggestedDonationMinimumNotMetMessage").show();
	},

	hideInvalidSuggestedDonationMessage(context, productCode) {
		this.findComponentFor(context, productCode, "suggestedDonationMinimumNotMetMessage").hide();
	}
};
